export const permissionsTabs = {
  1:[
    {
      code:"kernal:orgtab:prevorgplay",
      title:"所属机构计划"
    },
    {
      code:"enroll:orgtab:prevorgplay",
      title:"机构计划"
    },
    {
      code:"modifyBaseOrg",
      title:"机构管理编辑"
    }

  ],
  2:[
    {
      code:"HomeWorks:indexWorks",
      title:"工作台"
    },
    {
      code:"kernal:orgtab:provinceplay",
      title:"本省管理计划"
    },
    {
      code:"kernal:orgtab:orgplay",
      title:"本机构计划"
    },
    {
      code:"enroll:orgtab:provinceplay",
      title:"省管理计划"
    },
    // {
    //   code:"enroll:orgtab:prevorgplay",
    //   title:"上级机构计划"
    // },
    {
      code:"enroll:orgtab:orgplay",
      title:"本机构计划"
    },
    {
      code:"modifyBaseOrg",
      title:"机构管理编辑"
    },
    {
      code:"LocalSetList",
      title:"确认点列表"
    },
  ],
  3:[
    {
      code:"HomeWorks:indexWorks",
      title:"工作台"
    },

    {
      code:"Search:Select:county"
    },

    {
      code:"kernal:orgtab:provinceplay",
      title:"本省管理计划"
    },
    {
      code:"kernal:orgtab:orgplay",
      title:"机构计划"
    },
    // {
    //   code:"kernal:orgtab:nextorgplay",
    //   title:"下级机构计划"
    // },
    {
      code:"enroll:orgtab:provinceplay",
      title:"省管理计划"
    },
    // {
    //   code:"enroll:orgtab:prevorgplay",
    //   title:"上级机构计划"
    // },
    // {
    //   code:"enroll:orgtab:orgplay",
    //   title:"本机构计划"
    // },
    {
      code:"enroll:orgtab:nextorgplay",
      title:"机构计划"
    },
    {
      code:"modifyBaseOrg",
      title:"机构管理编辑"
    },
    {
      code:"LocalSetList",
      title:"确认点列表"
    },
  ],
  4:[
    {
      code:"HomeWorks:indexWorks",
      title:"工作台"
    },

    {
      code:"Search:Select:city"
    },
    {
      code:"Search:Select:county"
    },

    {
      code:"kernal:orgtab:provinceplay",
      title:"本省管理计划"
    },
    {
      code:"kernal:orgtab:orgplay",
      title:"机构计划"
    },
    // {
    //   code:"kernal:orgtab:nextorgplay",
    //   title:"下级机构计划"
    // },
    {
      code:"enroll:orgtab:provinceplay",
      title:"省管理计划"
    },

    // {
    //   code:"enroll:orgtab:orgplay",
    //   title:"本机构计划"
    // },
    {
      code:"enroll:orgtab:nextorgplay",
      title:"机构计划"
    },
    {
      code:"modifyBaseOrg",
      title:"机构管理编辑"
    },
    {
      code:"LocalSetList",
      title:"确认点列表"
    },
  ],

  5:[
    {
      code:"HomeWorks:index",
      title:"工作台"
    },
    {
      code:"Search:Select:province",
      title:"省份"
    },
    {
      code:"Search:Select:city",
      title:"市"
    },
    {
      code:"Search:Select:county",
      title:"县"
    },
    {
      code:"kernal:orgtab:certbatch",
      title:"认定批次"
    },
    {
      code:"kernal:orgtab:provinceplay",
      title:"省管理计划"
    },
    {
      code:"kernal:orgtab:nextorgplay",
      title:"机构计划"
    },
    {
      code:"enroll:orgtab:certbatch",
      title:"定期注册批次"
    },
    {
      code:"enroll:orgtab:provinceplay",
      title:"省管理计划"
    },
    {
      code:"enroll:orgtab:nextorgplay",
      title:"机构计划"
    },
    {
      code:"Search:Select:accessStatus",
      title:"是否准入查询"
    },

  ],
  6:[

  ],
  "4|manage":[
    {
      code:"HomeWorks:index",
      title:"工作台"
    },
    {
      code:"Search:Select:city"
    },
    {
      code:"Search:Select:county"
    },
    {
      code:"kernal:orgtab:certbatch",
      title:"认定批次"
    },
    {
      code:"kernal:orgtab:provinceplay",
      title:"本省管理计划"
    },
    {
      code:"kernal:orgtab:nextorgplay",
      title:"机构计划"
    },

    {
      code:"enroll:orgtab:certbatch",
      title:"注册批次"
    },
    {
      code:"enroll:orgtab:provinceplay",
      title:"本省管理计划"
    },
    {
      code:"enroll:orgtab:nextorgplay",
      title:"机构计划"
    },
    {
      code:"modifyBaseOrg",
      title:"机构管理编辑"
    },
  ],

};



export const permissionsBtn = {

  1:[
        {
          code:"kernalModel|RegistrationSubModel|StayExpExcel",
          title:"机构管理编辑"
        },
    ],
  2:[

  ],
  3:[

  ],
  4:[

  ],

  5:[


  ],
  6:[

  ],
  "4|manage":[

  ],

  "monitor":[
    {
      code:"ProvinceBatchSubModel|Province|addbtn",
      title:"管理本生计划新增"
    },
    {
      code:"ProvinceBatchSubModel|Province|Modbtn",
      title:"管理本生计划申请变更"
    },

    // {
    //   code:"ProvinceBatchSubModel|Province|Detailbtn",
    //   title:"管理本生计划查看"
    // },
    {
      code:"ProvinceBatchSubModel|Province|Editsbtn",
      title:"管理本生计划编辑"
    },
    {
      code:"ProvinceBatchSubModel|Province|ChangeRecordbtn",
      title:"管理本生计划变更记录"
    },
    {
      code:"CertBatchSubModel|delbtn",
      title:"删除批次信息"
    },
    {
      code:"CertBatchSubModel|endbtn",
      title:"结束批次信息"
    },
    {
      code:"CertBatchSubModel|modbtn",
      title:"编辑批次信息"
    },
    {
      code:"CertBatchSubModel|addbtn",
      title:"新增批次信息"
    },
    {
      code:"ProvinceBatchSubModel|Zgzx|Aud3btn",
      title:"省计划批次审批"
    },
    {
      code:"ProvinceBatchSubModel|Zgzx|Aud1btn",
      title:"省计划批次审批"
    },
    {
      code:"LocalSetSubModel|Addbtn",
      title:"安排确认点计划"
    },
    {
      code:"LocalSetSubModel|deleteLocaleSet",
      title:"取消确认点安排"
    },
    {
      code:"LocalSetSubModel|modifyLocaleSet",
      title:"修改确认点计划"
    },
    {
      code:"RegistrationSubModel|PrintBtn",
      title:"认定信息打印"
    },
    {
      code:"RegistrationSubModel|msgBtn",
      title:"给认定申请人留言"
    },
    {
      code:"RegistrationSubModel|querenBtn",
      title:"认定信息确认"
    },
    {
      code:"RegistrationSubModel|ApprovalBtn",
      title:"审批信息确认"
    },
    {
      code:"RegistrationAudSubModel|PrintBtn",
      title:"打印申请表"
    },

    {
      title: "准入查询",
      code:"RegistrationAudSubModel|AccessBtn",
    },
    {
      title:"准入查询结果复议",
      code:"RegistrationAudSubModel|AccessQueryApplyBtn",
    },

    {
      title: "审核通过暂不生成证书号码",
      code:"RegistrationAudSubModel|CertificateNoBtn",
    },

    {
      title: "生成证书号码",
      code:"RegistrationAudSubModel|GenCertificateNoBtn",
    },

    {
      title: "导入审核结论",
      code:"RegistrationAudSubModel|ImportBtn",
    },
    {
      title: "留言",
      code:"RegistrationAudSubModel|MsgBtn",
    },
    {
      title: "审批认定信息",
      code:"RegistrationAudSubModel|ApplyDetailBtn",
    },
    {
      title: "选择证书申请验证",
      code:"RegistrationAudSubModel|SelCertQueryBtn",
    },
    {
      title:"申请办结回传",
      code:"RegistrationAudSubModel|EndRegisterationBtn",
    },
    {
      title:"数据办结回传",
      code:"CompletionFinishModel|EndDataBackBtn",
    },
    {
      title: "申请结束省级计划",
      code:"ProvinceBatchSubModel|EndProvinceApply",
    },
    {
      title: "结束省级计划",
      code:"ProvinceBatchSubModel|EndProvincePlan",
    },
    {
      title:"申报未受理办结",
      code:"PrcessingData|applyNoReceivebtn",
    },
    {
      title: "网报待确认办结",
      code:"PrcessingData|Confirmedbtn",
    },

    {
      title: "确认未通过办结",
      code:"PrcessingData|NoPassbtn",
    },

    {
      title: "确认通过办结",
      code:"PrcessingData|qrPassbtn",
    },

    {
      title: "审批通过待编号办结",
      code:"PrcessingData|NoCertNobtn",
    },

    {
      title: "认定通过办结",
      code:"PrcessingData|Passbtn",
    },
    {
      title: "认定未通过办结",
      code:"PrcessingData|qrNoPassbtn",
    },







    //注册
    {
      code:"enroll|CertBatchSubModel|delbtn",
      title:"删除注册批次信息"
    },
    {
      code:"enroll|CertBatchSubModel|modbtn",
      title:"编辑注册批次信息"
    },
    {
      code:"enroll|ProvinceBatchSubModel|Province|addbtn",
      title:"注册管理本省计划新增"
    },
    {
      code:"enroll|ProvinceBatchSubModel|Province|Modbtn",
      title:"注册管理本省计划申请变更"
    },

    {
      code:"enroll|OrgBatchSubModel|addbtn",
      title:"设置本机构注册计划新增"
    },
    {
      code:"enroll|OrgBatchSubModel|updatebtn",
      title:"设置本机构注册计划修改"
    },

    {
      code:"enroll|LocaleSetSubModel|confirmWorkbtn",
      title:"安排确认点工作"
    },
    {
      code:"enroll|LocaleSetSubModel|deletebtn",
      title:"取消安排"
    },
    {
      code:"enroll|LocaleSetSubModel|editbtn",
      title:"编辑"
    },



    {
      code:"enroll|EnrollmentSubModel|printAcceptanceCertificate",
      title:"核对网络填报数据打印受理凭证"
    },

    {
      code:"enroll|EnrollmentSubModel|stayMessage",
      title:"核对网络填报数据留言"
    },

    {
      code:"enroll|EnrollmentSubModel|Confirmbtn",
      title:"核对网络填报数据确认"
    },


    {
      code:"enroll|OrgBatchSubModel|endRegisterbatchbtn",
      title:"结束定期注册计划-结束注册批次"
    },


    {
      code:"enroll|OrgBatchSubModel|endRegisterbatchaddbtn",
      title:"结束定期注册计划-结束注册批次"
    },

    {
      code:"enroll|OrgBatchSubModel|endTurnRegisterbatchaddbtn",
      title:"申请结束定期注册计划-结束并转数据"
    },



    {
      code:"enroll|EnrollAudSubModel|currentOrg|firstExamineQualified",
      title:"定期注册审批-初审合格"
    },

    {
      code:"enroll|EnrollAudSubModel|currentOrg|ImportDeclareNotAccepted",
      title:"定期注册审批-导入申报未受理"
    },

    {
      code:"enroll|EnrollAudSubModel|currentOrg|ImportRegisterNoRegInfo",
      title:"定期注册审批-导入应注册未报名信息"
    },

    {
      code:"enroll|EnrollAudSubModel|currentOrg|ImportRegisteredInconformityRegisterCondition",
      title:"定期注册审批-导入已报名却不符合注册条件信息"
    },

    {
      code:"enroll|EnrollAudSubModel|currentOrg|Export",
      title:"定期注册审批-本机构-导出"
    },


    {
      code:"enroll|EnrollAudSubModel|currentOrg|LeavingMessage",
      title:"定期注册审批-本机构-留言"
    },

    {
      code:"enroll|EnrollAudSubModel|currentOrg|Approval",
      title:"定期注册审批-本机构-审批"
    },

    {
      code:"enroll|viewConfirmationPointData|Accepted",
      title:"查看其他确认点数据-受理"
    },




  ]

}



// WEBPACK FOOTER //
// ./src/config/user.js